import { FC } from 'react';

import Stack from '@mui/material/Stack';
import TextField from 'components/TextField';
import Section from 'components/Section';
import SmtpTypeInput from 'components/SmtpTypeInput';

const GeneralSettingsEditFormSmtp: FC = () => (
  <Section id="smtp" title="SMTP Nustatymai">
    <Stack spacing={4}>
      <TextField fullWidth name="smtpName" label="Siuntėjo pavadinimas" />
      <TextField fullWidth name="smtpEmail" label="El. pašto adresas" />
      <TextField fullWidth name="smtpServer" label="SMTP serveris" />
      <TextField fullWidth name="smtpPort" label="Prievadas (port)" />
      <TextField fullWidth name="smtpUser" label="Vartotojas" />
      <TextField fullWidth name="smtpPassword" label="Slaptažodis" />
      <SmtpTypeInput name="smtpType" label="Ryšys" />
    </Stack>
  </Section>
);

export default GeneralSettingsEditFormSmtp;
